// src/components/AccessControl/UpgradePlanModal.tsx
import React from 'react';
import { Lock, ArrowRight, X } from 'lucide-react';
import './UpgradePlanModal.css';

interface UpgradePlanModalProps {
    isOpen: boolean;
    onClose: () => void;
    featureName?: string;
}

const UpgradePlanModal: React.FC<UpgradePlanModalProps> = ({ isOpen, featureName, onClose }) => {
    if (!isOpen) return null;

    const handleCatalog = () => {
        window.open('/catalogo', '_blank');
        onClose();
    };

    return (
        <div className="upgrade-modal-overlay" onClick={onClose}>
            <div className="upgrade-modal-box" onClick={e => e.stopPropagation()}>
                <button className="upgrade-modal-close-btn" onClick={onClose}>
                    <X size={18} />
                </button>

                <div className="upgrade-modal-icon-wrap">
                    <Lock size={36} />
                </div>

                <h2 className="upgrade-modal-title">Funcionalidade bloqueada</h2>

                {featureName && (
                    <p className="upgrade-modal-feature-badge">{featureName}</p>
                )}

                <p className="upgrade-modal-message">
                    Esta funcionalidade não está disponível no seu plano atual.
                    Evolua para os planos <strong>Combo</strong> ou <strong>Acesso Total</strong> para desbloquear.
                </p>

                <div className="upgrade-modal-actions">
                    <button className="upgrade-modal-btn-primary" onClick={handleCatalog}>
                        Ver Planos no Catálogo <ArrowRight size={16} />
                    </button>
                    <button className="upgrade-modal-btn-secondary" onClick={onClose}>
                        Agora não
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradePlanModal;